import { clsx } from "./auth-service-tools193.js";
const FOCUS_CLASS_NAMES = {
  always: "mantine-focus-always",
  auto: "mantine-focus-auto",
  never: "mantine-focus-never"
};

function getGlobalClassNames(_ref) {
  let {
    theme,
    options,
    unstyled
  } = _ref;
  return clsx((options == null ? void 0 : options.focusable) && !unstyled && (theme.focusClassName || FOCUS_CLASS_NAMES[theme.focusRing]), (options == null ? void 0 : options.active) && !unstyled && theme.activeClassName);
}

export { FOCUS_CLASS_NAMES, getGlobalClassNames };